import React, {useEffect, useState, useContext} from 'react';
import Reminder from './Reminder';
import {Alert, Button, Card, Col, Form, Row, Modal } from 'react-bootstrap';
import uuid from 'react-uuid';
import EventContext from '../Visitation/context';
import {ACTIONS as EVENT_ACTION} from './Event/action';

export default function Reminders()
{

  const {popup, dispatchPopup} = useContext(EventContext);

  const handleAddReminder = () => {
    dispatchPopup({
      type: EVENT_ACTION.UPDATE,
      payload: {
        reminders: [...popup.reminders, {
          uuid: uuid(),
          method: `popup`,
          minutes: 0,
        }]
      }
    });
  }

  return (
    <Form.Group>
      <Row>
        <Col md="12">
          <Form.Group>
            <Form.Label>Reminders</Form.Label>
          </Form.Group>
        </Col>
      </Row>
      {popup?.reminders && popup.reminders.map((reminder, key) => (
        <Reminder
          key={key}
          reminder={reminder}
        />
      ))}
      <Row>
        <Col>
          <Button variant="primary" onClick={handleAddReminder}>Add</Button>
        </Col>
      </Row>
    </Form.Group>
  );
}